import Info from "@mui/icons-material/Info";
import { Box, IconButton } from "@mui/material";

import { LightTooltip } from "./LightTooltip.js";

export interface InfoTooltipProps {
  text: string;
}

export const InfoTooltip = ({ text }: InfoTooltipProps) => (
  <LightTooltip
    title={<Box sx={{ whiteSpace: "pre-line" }}>{text}</Box>}
    placement="top-start"
  >
    <IconButton
      sx={{ paddingLeft: "5px" }}
      color="primary"
      aria-label="More information"
    >
      <Info />
    </IconButton>
  </LightTooltip>
);
